import anime from 'animejs/lib/anime.es.js';

// export function animatedArrow($thislink) {
//     // console.log("animated arrow", $thislink);
// //eye animated icon - need re-doing with anime.js < but having spent about an hour - leaving it for now.
// //https://codepen.io/ChrisBup/pen/LYQrMWd
// //https://yqnn.github.io/svg-path-editor/
// //https://animejs.com/

// const speed = 330; // Duration of the animation
//     // const easing = 'linear'; // Easing function
//     const easing = 'easeOutQuad';

//     // Selecting the SVG and path
//     const $thisarrow = $thislink;
//     const datapath = $thisarrow.find(".hover-icon").attr('data-path-hover');
//     const $thishovericon = $thisarrow.find('svg')[0];
//     const path = $thishovericon.querySelector('path');

//     // Store the original path data
//     const originalPath = path.getAttribute('d');

//     //  console.log("datapath", datapath);
//     //  console.log("path", path);
//     //  console.log("easing", easing);

//     // Mouse enter event
//     $thisarrow.on('mouseenter', function () {
//         // console.log("mouseenter");
//         anime({
//             targets: path,
//             d: datapath,
//             duration: speed,
//             easing: easing
//         });
//     });

//     // Mouse leave event
//     $thisarrow.on('mouseleave', function () {
//         // console.log('mouseleave');
//         anime({
//             targets: path,
//             d: originalPath,
//             duration: speed,
//             easing: easing
//         });
//     });
//     // console.log("end animated arrow");
// }

 
export function animatedArrow($thislink) {
    const speed = 330;
    const easing = 'easeInOutQuad';

    const $thisarrow = $thislink;
    const datapath = $thisarrow.find(".hover-icon").attr('data-path-hover');
    const $thishovericon = $thisarrow.find('svg')[0];
    const path = $thishovericon.querySelector('path');

    const originalPathData = path.getAttribute('d');

    $thisarrow.on('mouseenter', function () {
        anime({
            targets: path,
            d: [originalPathData, datapath],
            duration: speed,
            easing: easing
        });
    });

    $thisarrow.on('mouseleave', function () {
        anime({
            targets: path,
            d: [datapath, originalPathData],
            duration: speed,
            easing: easing
        });
    });
}